/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { getOptionLabelFromIndex } from '../../utils';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import { SafeHTML } from 'edrolo/domains/app';
import styles from './styles.scss';

const CHECKED_LARGE_SRC = `${global.__static__}img/exam-master/checked-large.png`;
const CHECKED_LARGE_2X_SRC = `${global.__static__}img/exam-master/checked-large@2x.png`;
const CORRECT_SRC = `${global.__static__}img/exam-master/correct.png`;
const CORRECT_2X_SRC = `${global.__static__}img/exam-master/correct@2x.png`;
const MISTAKE_LARGE_SRC = `${global.__static__}img/exam-master/mistake-large.png`;
const MISTAKE_LARGE_2X_SRC = `${global.__static__}img/exam-master/mistake-large@2x.png`;

export const SingleSelector = ({
  answers,
  correctAnswers,
  selectedAnswerId,
  onChange,
  disabled,
}) => {
  const isCorrectAnswer = (answerId) => {
    return correctAnswers && correctAnswers.indexOf(answerId) > -1;
  };

  const isIncorrectAnswer = (answerId) => {
    return correctAnswers && correctAnswers.indexOf(answerId) === -1;
  };

  const renderAnswers = () => {
    return answers.map((answer, index) => {
      const answerId = answer.get('id');
      const selected = answerId === +selectedAnswerId;
      const correct = isCorrectAnswer(answerId);
      const incorrect = isIncorrectAnswer(answerId);

      // Questions with more than 26 options will not show labels
      const optionLabel = getOptionLabelFromIndex(index);

      return (
        <li
          key={answerId}
          className={cx({
            [styles.selectedAnswer]: selected,
            [styles.answer]: !selected,
            [styles.disabledAnswer]: disabled,
          })}
          onClick={() => !disabled && onChange(answerId)}
          data-test="multi-choice-answer"
        >
          <span className={styles.optionLabel}>{optionLabel}</span>
          {selected && (
            <img
              className={styles.selectedIcon}
              src={CHECKED_LARGE_SRC}
              srcSet={`${CHECKED_LARGE_2X_SRC} 2x`}
              alt=""
              aria-hidden
            />
          )}
          {correct && selected && (
            <img
              className={styles.correctSelection}
              src={CORRECT_SRC}
              srcSet={`${CORRECT_2X_SRC} 2x`}
              alt="Correct answer selected"
              data-test="multi-choice-answer-correct"
            />
          )}
          {incorrect && selected && (
            <img
              className={styles.incorrectSelection}
              src={MISTAKE_LARGE_SRC}
              srcSet={`${MISTAKE_LARGE_2X_SRC} 2x`}
              alt="Incorrect answer selected"
              data-test="multi-choice-answer-incorrect"
            />
          )}
          <div
            className={correct ? styles.correctAnswerHtml : styles.answerHtml}
          >
            <SafeHTML>{answer.get('text')}</SafeHTML>
          </div>
        </li>
      );
    });
  };

  return (
    <ul
      className={styles.answers}
      data-test={`${disabled ? 'answer' : 'question'}-${
        EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE
      }`}
    >
      {renderAnswers()}
    </ul>
  );
};
